const ruComponents = {
    confirm: {
        title: "Вы уверены?",
        okText: "Да",
        noText: "Отмена",
    },
    loader: {
        defaultText: "Настраиваем телепорт...",
        firstText: "Привет... Сейчас начнем!",
    },
    inputUserId: {
        placeholder: "Укажите ID пользователя",
        errors: {
            notCorrect: "Укажите корректное значение",
        },
    },
    eq: {
        eq: "Предмет",
        selectEq: "Выберите предмет",
    },
    form: {
        isRequired: "Поле обязательно к заполнению",
        minLength: "Поле должно иметь не менее %s символов",
        maxLength: "Поле должно иметь не более %s символов",
        cancelBtn: "Отмена",
        submitBtn: "Сохранить",
        isNumber: "Значение должно быть числом",
        isDate: "Укажите корректную дату",
        isPhone: "Укажите корректный номер телефона",
        isEmail: "Укажите корректный Email",
        isSelectValue: "Выберите значение из списка",
        pattern: "Поле содержит недопустимые символы",
    },
    header: {
        langList: {
            title: "Выберите язык",
        },
    },
    navigationMenu: {
        menuList: {
            main: "Главная",
            user: "Профиль",
            games: "Маршруты",
            info: "Информация",
        },
    },
};
export default ruComponents;
